var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columnlistBox"},_vm._l((_vm.columnlist),function(item,index){return _c('div',{key:index,staticClass:"column_li"},[(_vm.isvdo)?_c('lisTemplatevdo',{attrs:{"list":item}}):_c('lisTemplate3',{attrs:{"list":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }